"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CtaButton = exports.CtaStyled = void 0;
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const shared_1 = require("../../shared");
const menu_hooks_1 = require("../../shared/menu.hooks");
const CtaDropdown_1 = require("./CtaDropdown");
exports.CtaStyled = styled_components_1.default.a `
	margin-left: 16px;
	height: 100%;
	background: transparent;
	align-items: center;
	justify-content: center;
	text-align: center;
	font-weight: 500;
	position: relative;
	span {
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		max-width: 220px;
		min-width: 100px;
		display: block;
		z-index: 2;
	}

	i,
	span {
		margin: 0;
	}

	transition: color 0.3s ${(p) => p.theme.easing};
	&:focus {
		outline-width: 2px;
	}

	&& {
		display: inline-flex;
		padding: 0 1em;
		color: ${(p) => p.theme.palette.accent.backgroundText};

		&:hover {
			&::after {
				opacity: 1;
			}
			color: ${(p) => p.theme.palette.accent.backgroundTextHover || p.theme.palette.accent.backgroundText};
		}
	}

	&::before,
	&::after {
		content: "";
		position: absolute;
		display: block;
		height: 100%;
		width: 100%;
		background: ${(p) => p.theme.palette.accent.background};
		transition: opacity 0.4s ${(p) => p.theme.easing};
	}

	&::after {
		background: ${(p) => p.theme.palette.accent.backgroundHover || p.theme.palette.accent.background};
		opacity: 0;
	}
`;
const CtaButton = ({ onClick, href = "#", title, node, dropdownDisabled, callToActionDropdown = {}, }) => {
    var _a;
    const closeMenus = (0, menu_hooks_1.useCloseAllMenus)();
    const onClickHandler = (e) => {
        if (e.button && e.button > 0)
            return;
        if (onClick && typeof onClick === "function") {
            onClick(e);
        }
        closeMenus();
    };
    const onKeyUp = (0, shared_1.useHandleKeyUp)(onClickHandler);
    /**
     * When enabled and with valid props the cta dropdown should be used.
     * Currently the dropdown is only supported on mobile when in 'topNav' position.
     */
    if (!dropdownDisabled &&
        (callToActionDropdown === null || callToActionDropdown === void 0 ? void 0 : callToActionDropdown.title) &&
        ((_a = callToActionDropdown === null || callToActionDropdown === void 0 ? void 0 : callToActionDropdown.links) === null || _a === void 0 ? void 0 : _a.length) &&
        !callToActionDropdown.disabled) {
        return react_1.default.createElement(CtaDropdown_1.CtaDropdown, Object.assign({}, callToActionDropdown));
    }
    if (!node && !title) {
        return null;
    }
    return (react_1.default.createElement(exports.CtaStyled, { className: "cta", id: "cta", tabIndex: 0, href: href, onClick: onClickHandler, onMouseDown: epic_games_nav_shared_1.stopFocusOnClick, onKeyUp: onKeyUp },
        react_1.default.createElement("span", null, node || title)));
};
exports.CtaButton = CtaButton;
//# sourceMappingURL=CtaButton.js.map